/* eslint-disable @typescript-eslint/no-explicit-any */
import { firebaseLogEvent } from '@biniyog/firebase';
import React, { useContext, useEffect, useState } from 'react';
import { LanguageContext } from './LanguageContext';
import './LanguageToggle.scss';
type LanguageToggleProp = {
  style?: React.CSSProperties;
};
export function LanguageToggle({ style = {} }: LanguageToggleProp) {
  const [lan, setLan] = useState<'en' | 'bn'>('en');
  const { changeLanguage } = useContext(LanguageContext);
  useEffect(() => {
    const btn: any = document.getElementById('lan-btn');
    const enBtn: any = document.getElementById('en');
    const bnBtn: any = document.getElementById('bn');

    if (lan === 'en') {
      btn.style.left = '30px';
      enBtn.style.color = 'black';
      bnBtn.style.color = '#fff';
    }
    if (lan === 'bn') {
      btn.style.left = '2px';
      enBtn.style.color = '#fff';
      bnBtn.style.color = 'black';
    }
    changeLanguage && changeLanguage(lan);
  }, [lan]);
  return (
    <div className="button-box" style={style}>
      <div id="lan-btn" className={lan}></div>
      <button
        id="bn"
        type="button"
        className="toggle-btn"
        onClick={(e) => {
          setLan('bn');
        }}
      >
        অ
      </button>
      <button
        type="button"
        className="toggle-btn"
        id="en"
        onClick={(e) => {
          setLan('en');
          firebaseLogEvent('translation_toggle');
        }}
      >
        EN
      </button>
    </div>
  );
}
